<template>
  <div>
    <nav-bar />
    <v-container fluid>
      <v-row align-content="space-around">
        <v-col cols="12">
          <v-card outlined>
            <v-card-title> Mqtt Command to multiple devices </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-form v-model="valid" ref="form">
                <v-radio-group
                  row
                  v-model="deviceType"
                  label="Device Type : "
                  :rules="rules"
                >
                  <v-radio label="Ecotron" value="ecotron"></v-radio>
                  <v-radio label="Ecofrost" value="ecofrost"></v-radio>
                </v-radio-group>
                <v-textarea
                  outlined
                  label="MQTT Command"
                  placeholder=" "
                  rounded
                  no-resize
                  :rules="rules"
                  v-model="command"
                  :rows="3"
                ></v-textarea>
                <v-textarea
                  outlined
                  label="Device Serial Numbers"
                  placeholder="Comma Seperated Serial Numbers Eg: EZMCI19120358,EZMCI19120359,EZMCI19120360"
                  auto-grow
                  :rules="rules"
                  v-model="listOfDeviceIds"
                  rounded
                ></v-textarea>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" @click="executeCommand" :loading="loading">
                <v-icon left>mdi-powershell</v-icon>
                Execute
              </v-btn>
            </v-card-actions>
            <v-divider></v-divider>
            <p class="caption font-italic font-weight-light mb-0 pl-2">
              Note: Use it only in case of single mqtt response for individual
              mqtt command.
            </p>
          </v-card>
        </v-col>
      </v-row>
      <v-row align-content="space-around" v-if="mqttResponseReceived">
        <v-col cols="12">
          <v-card outlined>
            <v-card-title> Mqtt Responses </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-card outlined>
                <v-data-table :headers="headers" :items="items"> </v-data-table>
              </v-card>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';
import { dateFormat } from '../plugins/date';
import NavBar from '../components/NavBar';
export default {
  name: 'mqtt-multiple-devices',
  components: { NavBar },
  data() {
    return {
      valid: true,
      deviceType: null,
      rules: [value => !!value || 'Required'],
      listOfDeviceIds: '',
      loading: false,
      command: '',
      items: [],
      headers: [
        {
          text: 'Serial No.',
          value: 'deviceId'
        },
        {
          text: 'Mqtt Response',
          value: 'mqttMessage'
        },
        {
          text: 'Timestamp',
          value: 'timestamp'
        }
      ],
      mqttResponseReceived: false
    };
  },
  methods: {
    async executeCommand() {
      this.mqttResponseReceived = false;
      this.loading = true;
      this.$store.commit('setError', false);
      try {
        if (this.$refs.form.validate()) {
          this.loading = true;
          const response = await axios({
            baseURL: 'https://api.ecozen.ai/mqtt/v1',
            method: 'POST',
            url: `${this.deviceType}`,
            data: {
              command: this.command,
              [this.deviceType === 'ecofrost'
                ? 'ecofrostSerialNoArray'
                : 'ecotronSerialNoArray']: this.listOfDeviceIds
                .split(',')
                .map(id => id.trim())
                .filter(Boolean)
            }
          });
          this.mqttResponseReceived = true;
          this.items = response.data.map(element => {
            return {
              ...element,
              timestamp: dateFormat(element.timestamp),
              mqttMessage: element.mqttMessage.replace('\n', ' ')
            };
          });
        }
      } catch (error) {
        if (error.isAxiosError) {
          if (error.response.status === 503) {
            this.mqttResponseReceived = true;
            this.items = error.response.data.error.capturedMessages.map(
              element => {
                return {
                  ...element,
                  timestamp: element.timestamp
                    ? dateFormat(element.timestamp)
                    : 'N/A',
                  mqttMessage: element.mqttMessage.replace('\n', ' ')
                };
              }
            );
          } else {
            this.$store.commit('setError', error.response.data.error.message);
          }
        } else {
          this.$store.commit('setError', error);
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
